/** * * Asynchronously loads the component for
SubmitTicket
* */ import { lazyLoad } from "utils/loadable";
export const SubmitTicket = lazyLoad(
  () => import("./index"),
  (module) => module.SubmitTicket
);
